import { cn } from '@/lib/utils';
import { euroRange } from './pipelineFormat';

/**
 * De afsluitregel onder beide weergaven: hoeveel offertes je ziet en wat ze
 * samen waard zijn. Het totaal stond nergens, terwijl het de vraag is die een
 * salesmanager als eerste stelt bij een gefilterde lijst.
 */
export function QuoteTotalsFooter({
  shownCount,
  totalCount,
  totalCents,
  totalMaxCents,
  noun = 'offerte',
  className,
}: {
  shownCount: number;
  totalCount: number;
  totalCents: number;
  /** Bovenkant wanneer er offertes met een van–tot prijs tussen zitten. */
  totalMaxCents?: number;
  noun?: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-wrap items-center justify-between gap-3 px-4 py-3 text-sm text-muted-foreground',
        className,
      )}
    >
      <span>
        {shownCount === totalCount
          ? `${shownCount} ${shownCount === 1 ? noun : `${noun}s`}`
          : `${shownCount} van ${totalCount} ${noun}s getoond`}
      </span>
      <span className="flex items-center gap-3">
        Totale waarde
        <span className="text-base font-bold tabular-nums text-foreground">{euroRange(totalCents, totalMaxCents)}</span>
      </span>
    </div>
  );
}

export default QuoteTotalsFooter;
